import React, { useEffect, useState } from "react";
import i18n from "../../util/i18n";
import { useColor } from "../../util/ColorContext";

const Header = () => {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const { color } = useColor();

  const changeLanguage = (lng) => {
    i18n
      .changeLanguage(lng)
      .then(() => {
        console.log(`Language changed to ${lng}`);
        setCurrentLanguage(lng);
      })
      .catch((error) => {
        console.error("Error changing language:", error);
      });
  };

  useEffect(() => {
    setCurrentLanguage("en");
  }, []);

  return (
    <header style={{ color }}>
      <h1>SPETTRUM</h1>
      <div className="language-switcher">
        <button
          onClick={() => changeLanguage("ko")}
          style={{
            fontWeight: currentLanguage === "ko" ? "bold" : "lighter",
            color: { color },
          }}
        >
          <span className="header__button" style={{ color }}>
            KOR
          </span>
        </button>{" "}
        |{" "}
        <button
          onClick={() => changeLanguage("en")}
          style={{
            fontWeight: currentLanguage === "en" ? "bold" : "lighter",
            color: { color },
          }}
        >
          <span className="header__button" style={{ color }}>
            ENG
          </span>
        </button>
      </div>
    </header>
  );
};

export default Header;
